import { Directive, ElementRef, Input, Renderer2, inject } from '@angular/core';

@Directive({
    selector: 'img[alphaImageDisplay]',
    standalone: true,
})
export class ImageDisplayDirective {
    private el = inject<ElementRef<HTMLImageElement>>(ElementRef);
    private renderer = inject(Renderer2);

    @Input() alphaImageDisplay!: string;

    ngAfterViewInit() {
        this.el.nativeElement.onerror = this.setFallbackImage.bind(this);
    }

    private setFallbackImage() {
        this.renderer.setAttribute(this.el.nativeElement, 'src', this.alphaImageDisplay);
    }
}
